import { ReduxState } from 'app-types'
import get from 'lodash/get'
import { Payment } from './model'

export const getAmount = (state: ReduxState): number => get(state, 'payment.amount')

export const getPaymentDetails = (state: ReduxState): Payment => get(state, 'payment')
